import * as A from 'fp-ts/Array';
import * as Opt from 'fp-ts/Option';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/function';
import { Locale } from 'modules/domains/template';

export const executeLocaleRemoval = async (
  removeLocale: (templateId: number, locale: string) => Promise<unknown>,
  templateId: number,
  localesToRemove: Opt.Option<Partial<Locale>[]>,
) => {
  return pipe(
    localesToRemove,
    A.fromOption,
    A.flatten,
    A.map((v) => {
      return TE.tryCatch(
        () => removeLocale(templateId, v?.tag as string),
        () => {
          // Eventually log error to data dog
        },
      );
    }),
    TE.sequenceSeqArray,
  )();
};
